import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormControl } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { KpiRequest } from 'src/app/domains/kpi/models/index';
import { KpiService } from 'src/app/domains/kpi/services/index';
import { NotificationService } from 'src/app/shared/services/notification/notification.service';

@Component({
  selector: 'gdp-kpi',
  templateUrl: './kpi.component.html',
  styleUrls: ['./kpi.component.scss']
})
export class KpiComponent implements OnInit {
  dataForm: UntypedFormGroup;
  safeEmailTemplate: SafeHtml;
  public loading: boolean = false;

  constructor(
    private sanitizer: DomSanitizer,
    private kpiService: KpiService,
    private notification: NotificationService
  ) { }

  ngOnInit(): void {
    this.dataForm = new UntypedFormGroup({
      'kpiMonth': new UntypedFormControl('', Validators.required),
      'kpiYear': new UntypedFormControl('', Validators.required),
      'totalCustomers': new UntypedFormControl('', Validators.required),
      'mrr': new UntypedFormControl('', Validators.required),
      'mrrGrowth': new UntypedFormControl('', Validators.required),
      'paidSubscriptionChurn': new UntypedFormControl('', Validators.required),
      'quote': new UntypedFormControl(''),
      newCustomers: new UntypedFormGroup({
        'current': new UntypedFormControl(''),
        'goal': new UntypedFormControl('')
      }, this.currentGoalValidator),
      itaNewMrrDirect: new UntypedFormGroup({
        'current': new UntypedFormControl(''),
        'goal': new UntypedFormControl('')
      }, this.currentGoalValidator),
      itaNewMrrIndirect: new UntypedFormGroup({
        'current': new UntypedFormControl(''),
        'goal': new UntypedFormControl('')
      }, this.currentGoalValidator)
      // ukNewMrrDirect: new FormGroup({
      //   'current': new FormControl(''),
      //   'goal': new FormControl('')
      // }, this.currentGoalValidator),
      // usaNewMrrDirect: new FormGroup({
      //   'current': new FormControl(''),
      //   'goal': new FormControl('')
      // }, this.currentGoalValidator)
    });

    this.safeEmailTemplate = this.sanitizer.bypassSecurityTrustHtml(
      this.kpiService.getTemplateCode(
        {
          kpiMonth: 'February',
          kpiYear: 2022,
          totalCustomers: 1328,
          mrr: 113.450,
          mrrGrowth: 4.76,
          paidSubscriptionChurn: 2.86,
          quote: '“The most important step in becoming successful in anything is to first become interested in it." (Sir William Osler)',
          newCustomersCurrent: 72,
          newCustomersGoal: 72,
          itaNewMrrDirectCurrent: 3920,
          itaNewMrrDirectGoal: 2933,
          itaNewMrrIndirectCurrent: 1334,
          itaNewMrrIndirectGoal: 923,
          newCustomersWidth: this.kpiService.calculateWidth(72, 72),
          itaNewMrrDirectWidth: this.kpiService.calculateWidth(3920, 2933),
          itaNewMrrIndirectWidth: this.kpiService.calculateWidth(1334, 923)
          // ukNewMrrDirectCurrent:0,
          // ukNewMrrDirectGoal:0,
          // usaNewMrrDirectCurrent:0,
          // usaNewMrrDirectGoal:1.823
        }
      )
    );
  }

  generateKPI() {
    if (this.dataForm.valid) {
      const value = this.dataForm.value;
      const request: KpiRequest = {
        kpiMonth: value.kpiMonth,
        kpiYear: value.kpiYear,
        totalCustomers: value.totalCustomers,
        mrr: value.mrr,
        mrrGrowth: value.mrrGrowth,
        paidSubscriptionChurn: value.paidSubscriptionChurn,
        quote: value.quote,
        newCustomersCurrent: this.dataForm.get(['newCustomers', 'current']).value,
        newCustomersGoal: this.dataForm.get(['newCustomers', 'goal']).value,
        itaNewMrrDirectCurrent: this.dataForm.get(['itaNewMrrDirect', 'current']).value,
        itaNewMrrDirectGoal: this.dataForm.get(['itaNewMrrDirect', 'goal']).value,
        itaNewMrrIndirectCurrent: this.dataForm.get(['itaNewMrrIndirect', 'current']).value,
        itaNewMrrIndirectGoal: this.dataForm.get(['itaNewMrrIndirect', 'goal']).value,
        newCustomersWidth: this.kpiService.calculateWidth(this.dataForm.get(['newCustomers', 'current']).value, this.dataForm.get(['newCustomers', 'goal']).value),
        itaNewMrrDirectWidth: this.kpiService.calculateWidth(this.dataForm.get(['itaNewMrrDirect', 'current']).value, this.dataForm.get(['itaNewMrrDirect', 'goal']).value),
        itaNewMrrIndirectWidth: this.kpiService.calculateWidth(this.dataForm.get(['itaNewMrrIndirect', 'current']).value, this.dataForm.get(['itaNewMrrIndirect', 'goal']).value)
        // ukNewMrrDirectCurrent: this.dataForm.get(['ukNewMrrDirect', 'current']).value,
        // ukNewMrrDirectGoal: this.dataForm.get(['ukNewMrrDirect', 'goal']).value,
        // usaNewMrrDirectCurrent: this.dataForm.get(['usaNewMrrDirect', 'current']).value,
        // usaNewMrrDirectGoal: this.dataForm.get(['usaNewMrrDirect', 'goal']).value
      }
      this.safeEmailTemplate = this.sanitizer.bypassSecurityTrustHtml(
        this.kpiService.getTemplateCode(request)
      );
    }
  }

  sendKPIEmail() {
    this.loading = true;
    this.kpiService
      .sendKpiEmail(
        this.dataForm.value,
        this.kpiService.calculateWidth(this.dataForm.get(['newCustomers', 'current']).value, this.dataForm.get(['newCustomers', 'goal']).value),
        this.kpiService.calculateWidth(this.dataForm.get(['itaNewMrrDirect', 'current']).value, this.dataForm.get(['itaNewMrrDirect', 'goal']).value),
        this.kpiService.calculateWidth(this.dataForm.get(['itaNewMrrIndirect', 'current']).value, this.dataForm.get(['itaNewMrrIndirect', 'goal']).value)
      )
      .subscribe(
        () => {
          this.loading = false;
          this.notification.success('kpi.notifications.success');
        },
        () => {
          this.loading = false;
        }
      )
  }

  isInvalid(name: string): boolean {
    return this.dataForm.get(name).invalid && (this.dataForm.get(name).dirty || this.dataForm.get(name).touched);
  }

  get newCustomers() {
    return this.dataForm.get('newCustomers');
  }
  get itaNewMrrDirect() {
    return this.dataForm.get('itaNewMrrDirect');
  }
  get itaNewMrrIndirect() {
    return this.dataForm.get('itaNewMrrIndirect');
  }
  // get ukNewMrrDirect() {
  //   return this.dataForm.get('ukNewMrrDirect');
  // }
  // get usaNewMrrDirect() {
  //   return this.dataForm.get('usaNewMrrDirect');
  // }

  currentGoalValidator(g: UntypedFormGroup) {
    let formControls = g.controls;

    if ((formControls.current.value != '' && formControls.goal.value != '')
      || (formControls.current.value === '' && formControls.goal.value === '')) {
      return null;
    }
    else if (formControls.current.value != '' && formControls.goal.value == '') {
      return {
        current: false,
        goal: true
      }
    } else if (formControls.current.value == '' && formControls.goal.value != '') {
      return {
        current: true,
        goal: false
      }
    } else {
      return {
        current: true,
        goal: true
      }
    }
  }

}
